import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGUAGES, getTranslation } from "./i18n";

const LangContext = createContext({
  lang: "de",
  setLang: () => {},
  t: getTranslation("de"),
  languages: LANGUAGES,
});

const STORAGE_KEY = "zemi.lang";

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "de";
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
    const nav = (window.navigator.language || "de").slice(0, 2).toLowerCase();
    return LANGUAGES.some((l) => l.code === nav) ? nav : "de";
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    try {
      window.localStorage.setItem(STORAGE_KEY, code);
      document.documentElement.lang = code;
    } catch (e) {
      // ignore
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = {
    lang,
    setLang,
    t: getTranslation(lang),
    languages: LANGUAGES,
  };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
